import React, { Component } from "react";
import {
  View,
  StyleSheet,
  Text,
  FlatList,
  TouchableOpacity,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { Button } from "react-native-elements";

import useStatusBar from "../hooks/useStatusBar";
import { logout } from "../components/Firebase/firebase";
import * as firebase from "firebase";
import { auth } from "firebase";
import Colors from "../utils/colors";
import ProfilePic from "./ProfilePic";
import IndustryList from "./IndustryList";
import deepCompare from "./CompareObjs";
import Ionicons from "@expo/vector-icons/Ionicons";
import Icon from "react-native-vector-icons/FontAwesome";

const NUM_OF_INDUSTRIES = 10;
const getPreviousMonday = () => {
  var prevMonday = new Date();
  prevMonday.setDate(prevMonday.getDate() - ((prevMonday.getDay() + 6) % 7));
  const getStringFormatOfDate = (date) => {
    var dd = String(date.getDate()).padStart(2, "0");
    var mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = date.getFullYear();

    let strDate = dd + "-" + mm + "-" + yyyy;
    return strDate;
  };
  return getStringFormatOfDate(prevMonday);
};
export default class Profile extends Component {
  state = {
    dateBeginning: getPreviousMonday(),
    //dateBeginning:"15-03-2021",

    industryList: [],

    pointsArr: [],
  };
  async componentDidMount() {
    this.getUserStocks();
  }
  handleSignOut = async () => {
    try {
      await logout();
    } catch (error) {
      console.log(error);
    }
  };

  getResultStocks = (date, industry, yourStocks) => {
    // want to see last week picks and detailed results
    // want to see overall analysis
    firebase
      .database()
      .ref("results/" + date + "/" + industry)
      .once("value")
      .then((snapshot) => {
        const vals = snapshot.val();
        if (vals !== null) {
          this.calcStockScore(yourStocks, vals);
        } else {
          this.setState({
            pointsArr: [],
          });
        }
        return vals;
      });
  };

  getUserStocks = () => {
    // want to see last week picks and detailed results
    // want to see overall analysis

    let uid =
      this.props.route.params === undefined
        ? auth().currentUser.uid
        : this.props.route.params.uid;
    firebase
      .database()
      .ref("userPicks/" + uid + "/")
      // .orderByKey()
      // .limitToLast(1)
      .once("value")
      .then((snapshot) => {
        let vals = snapshot.val();

        // vals = vals[this.getPreviousMonday()];

        if (vals !== null) {
          vals = vals[this.state.dateBeginning];
          let newIndustryList = [];

          if (vals !== undefined) {
            // gets filled in industries
            // Object.keys(vals).map(val=>newIndustryList.push(IndustryList[IndustryList.findIndex(el=>el["name"]===val)]))

            for (var key of Object.keys(vals)) {
              newIndustryList.push(
                IndustryList[IndustryList.findIndex((el) => el["name"] === key)]
              );

              // this.getResultStocks(this.getPreviousMonday(),key,vals[key])
              this.getResultStocks(this.state.dateBeginning, key, vals[key]);
            }
          }
          this.setState({
            industryList: newIndustryList,
          });
        }
      });
  };
  calcStockScore = (yourStocks, correctStocks) => {
    let points = 0;
    for (let i = 0; i < yourStocks.length; i++) {
      const yourStock = yourStocks[i];
      const correctStock = correctStocks[i];

      if (deepCompare(yourStock, correctStock)) {
        points += 1;
      }
    }

    let newPointsArr = [...this.state.pointsArr];
    newPointsArr.push(points);
    console.log(newPointsArr);
    this.setState({
      pointsArr: newPointsArr,
    });
  };

  render() {
    return (
      <View style={styles.mainContainer}>
        <FlatList
          numColumns={1}
          data={this.state.industryList}
          ListHeaderComponent={
            <View>
              {this.props.route.params === undefined ? (
                <View
                  style={{
                    backgroundColor: "#011936",
                    padding: 15,
                    paddingTop: 35,
                    alignItems: "center",
                  }}
                >
                  <Text style={{ fontSize: 25, color: "white" }}>Profile</Text>

                  <Button
                    title=""
                    containerStyle={{
                      position: "absolute",
                      right: 0,
                    }}
                    type="clear"
                    onPress={() => {
                      this.props.navigation.navigate("Settings");
                    }}
                    icon={<Ionicons name="md-more" size={52} color="white" />}
                  />
                </View>
              ) : null}
              <ProfilePic
                navigation={this.props.navigation}
                uid={
                  this.props.route.params === undefined
                    ? auth().currentUser.uid
                    : this.props.route.params.uid
                }
              />
              <View style={styles.container}>
                <Text style={styles.paragraph}>Week: </Text>
                <Text style={styles.paragraphRight}>
                  {this.state.dateBeginning}
                </Text>
              </View>
              <View style={styles.container}>
                <Text style={styles.paragraph}>Total accuracy:</Text>
                <Text style={styles.paragraphRight}>
                  {this.state.industryList.length !== 0
                    ? (
                        this.state.pointsArr.reduce((a, b) => a + b, 0) *
                        (20 / this.state.industryList.length)
                      ).toFixed(2) + "%"
                    : (
                        this.state.pointsArr.reduce((a, b) => a + b, 0) 
                      ).toFixed(2) + "%"}
                </Text>
              </View>

              <View style={styles.container}>
                <Text style={styles.paragraph}>Total attempted:</Text>
                <Text style={styles.paragraphRight}>
                  {(this.state.industryList.length / NUM_OF_INDUSTRIES) * 100 +
                    "%"}
                </Text>
              </View>

              {/* <Button title="Sign Out" onPress={this.handleSignOut} /> */}
            </View>
          }
          renderItem={(item) => {
            return (
              <TouchableOpacity
                onPress={() => {
                  this.state.pointsArr.length !== 0
                    ? this.props.navigation.navigate("PicksView", {
                        name: item["item"]["name"],
                        uid:
                          this.props.route.params === undefined
                            ? auth().currentUser.uid
                            : this.props.route.params.uid,
                        date: this.state.dateBeginning,
                      })
                    : null;
                }}
              >
                <LinearGradient
                  // Button Linear Gradient
                  colors={item["item"]["color"]}
                  style={{
                    height: 100,
                    margin: 5,
                    alignItems: "center",
                    borderRadius: 20,
                    padding: 15,
                    justifyContent: "space-between",
                    flexDirection: "row",
                  }}
                >
                  <Text
                    style={{
                      backgroundColor: "transparent",
                      fontSize: 20,
                      color: "black",
                      textAlign: "left",
                    }}
                  >
                    {item["item"]["name"]}
                  </Text>
                  <Text
                    style={{
                      backgroundColor: "transparent",
                      fontSize: 20,
                      color: "black",
                      textAlign: "right",
                    }}
                  >
                    {this.state.pointsArr.length > item.index
                      ? this.state.pointsArr[item.index] + "/5"
                      : ""}
                  </Text>
                </LinearGradient>
              </TouchableOpacity>
            );
          }}
          keyExtractor={(item, index) => "key" + index}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  mainContainer: {
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 30,
    flex: 1,
  },
  container: {
    justifyContent: "space-between",
    flexDirection: "row",
    color: "white",
    marginTop: 15,
  },
  paragraph: {
    fontSize: 25,
    color: "white",

    textAlign: "left",
  },
  paragraphRight: {
    fontSize: 25,
    color: "white",

    textAlign: "right",
  },
});
